export function DocumentTextEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="136"
        viewBox="0 0 200 136"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M72 30H118L138 50V120C138 126.667 134.667 130 128 130H72C65.3333 130 62 126.667 62 120V40C62 33.3333 65.3333 30 72 30Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path d="M118 30V50H138" fill="var(--clr-border-grey-100)" />
        <path
          d="M86 70C90 74.6667 94 74.6667 98 70"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M106 70C110 74.6667 114 74.6667 118 70"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M94 84C99.3333 88 104.667 88 110 84"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M80.5 82.5C82.1569 82.5 83.5 81.1569 83.5 79.5C83.5 77.8431 82.1569 76.5 80.5 76.5C78.8431 76.5 77.5 77.8431 77.5 79.5C77.5 81.1569 78.8431 82.5 80.5 82.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M120.5 82.5C122.157 82.5 123.5 81.1569 123.5 79.5C123.5 77.8431 122.157 76.5 120.5 76.5C118.843 76.5 117.5 77.8431 117.5 79.5C117.5 81.1569 118.843 82.5 120.5 82.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M74 106.5H122C121.337 106.5 120.701 106.447 120.232 106.354C119.763 106.26 119.5 106.133 119.5 106C119.5 105.867 119.763 105.74 120.232 105.646C120.701 105.553 121.337 105.5 122 105.5H74C74.663 105.5 75.2989 105.553 75.7678 105.646C76.2366 105.74 76.5 105.867 76.5 106C76.5 106.133 76.2366 106.26 75.7678 106.354C75.2989 106.447 74.663 106.5 74 106.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.75"
          d="M74 117.5H106C105.337 117.5 104.701 117.447 104.232 117.354C103.763 117.26 103.5 117.133 103.5 117C103.5 116.867 103.763 116.74 104.232 116.646C104.701 116.553 105.337 116.5 106 116.5H74C74.663 116.5 75.2989 116.553 75.7678 116.646C76.2366 116.74 76.5 116.867 76.5 117C76.5 117.133 76.2366 117.26 75.7678 117.354C75.2989 117.447 74.663 117.5 74 117.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M34 72C41.3333 76 49.3333 76.6667 58 74"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          opacity="0.9"
          d="M28.0002 71C21.1542 68.7346 19.0363 62.7752 23.1487 58.2932C28.4187 61.79 29.921 66.9614 28.0002 71Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M28.0002 71C24.5034 76.27 18.1007 76.1963 14.4067 71.4682C19.1348 67.7742 24.1338 67.6756 28.0002 71Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M164 104L166 109L171 111L166 113L164 118L162 113L157 111L162 109L164 104Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M92.0004 10.6C93.4363 10.6 94.6004 9.43597 94.6004 8.00002C94.6004 6.56408 93.4363 5.40002 92.0004 5.40002C90.5645 5.40002 89.4004 6.56408 89.4004 8.00002C89.4004 9.43597 90.5645 10.6 92.0004 10.6Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
